import { Observable } from "rxjs";
import { RealObjectStructure } from "../../../../shared/services/remote-data/machine-one.service";
import { TramoggiaState } from "./partsModels/tramoggia-part";

export interface IMachineConfig {
    name: string;
    type: string;
    sections: ISection[];

    slidesCount: number;
}

export interface ISection {
    hopperAnalogLevel$: Observable<number>;

    hopperAnalogLevel: number;
    slides: ISlide[];
}

export interface ISlide {
    isRunnung$: Observable<boolean>;
    isPaused$: Observable<boolean>;
    systemState$: Observable<string>;

    systemState: string;
    isHalfSlide: boolean;
    state: TramoggiaState;
    cameras: ICamera[];
}

export interface ICamera {
    systemState$: Observable<string>;

    systemState: string;
    position: string;
}

export interface IMachineItem {
    structureName: string;
    valueId: number | undefined;
    items: IMachineItem[] | undefined;
}

export class MachineConfigUtils {

    public static resolveMachineConfigurationStructure(machineStructureRaw: string): IMachineItem[] {
        let parsedConfig = JSON.parse(machineStructureRaw);
        return [this.resolveMachineItem( "MachineOne", parsedConfig.MachineOne)];
    }

    public static resolveMachineItem(paramName: string, obj: any): IMachineItem {
        // resolve structure name
        let structureName = obj.hasOwnProperty('_L') ? obj._L : paramName;
        // create new machine item
        let machineItem: IMachineItem = {
            structureName: structureName,
            valueId: undefined,
            items: undefined
        }

        let items: IMachineItem[] = [];
        // resolve value id
        if(obj.hasOwnProperty('_V')) {
            if(Array.isArray(obj._V)) {
                obj._V.forEach((value: any, index: number) => {
                    items.push(this.resolveMachineItem(structureName + " " + index, value));
                });
            } else {
                machineItem.valueId = obj._ID;
            }
        } else {
            for (let key in obj) {
                if (key === '_L' || key === '_ID' || key === '_V' || key === '_T' || key === '_N') {
                    continue;
                }
                if (obj[key].hasOwnProperty('_ID')) {
                    items.push(this.resolveMachineItem(key, obj[key]));
                }
            }
        }

        if (items.length > 0) {
            machineItem.items = items;
        }

        return machineItem;
    }

    public static resolveMachineConfigurationFromJson(machineStructureRaw: string, machineStructure: any): IMachineConfig {
        let parsedConfig = JSON.parse(machineStructureRaw);

        let newConfig:IMachineConfig = {
            name: parsedConfig.MachineOne.MachineType._V,
            type: parsedConfig.MachineOne.MachineType._V,
            sections: [],
            slidesCount: 0
        };

        parsedConfig.MachineOne.Sections._V.forEach((section: any, sectionIndex: number) => {
            let newSection: ISection = {
                hopperAnalogLevel$: machineStructure.MachineOne.Sections[sectionIndex].HopperAnalogLevel,
                hopperAnalogLevel: section.HopperAnalogLevel._V,
                slides: []
            };

            section.Slides._V.forEach((slide: any, slideIndex: number) => {
                // resolve state
                let state: TramoggiaState = TramoggiaState.DISABLED;
                if (slide.Vibrator.IsRunning._V) {
                    state = TramoggiaState.RUNNING;
                } else if (slide.Vibrator.IsPaused._V) {
                    state = TramoggiaState.PAUSED;
                }

                let newSlide: ISlide = {
                    isRunnung$: machineStructure.MachineOne.Sections[sectionIndex].Slides[slideIndex].Vibrator.IsRunning,
                    isPaused$: machineStructure.MachineOne.Sections[sectionIndex].Slides[slideIndex].Vibrator.IsPaused,
                    systemState$: machineStructure.MachineOne.Sections[sectionIndex].Slides[slideIndex].SystemState,

                    systemState: slide.SystemState._V,
                    isHalfSlide: slide.IsHalfSlide._V,
                    state: state,
                    cameras: []
                };

                newConfig.slidesCount = (newSlide.isHalfSlide) ? newConfig.slidesCount + 0.5 : newConfig.slidesCount + 1;

                slide.Cameras._V.forEach((camera: any, cameraIndex: number) => {
                    newSlide.cameras.push({
                        systemState$: machineStructure.MachineOne.Sections[sectionIndex].Slides[slideIndex].Cameras[cameraIndex].SystemState,
                        systemState: camera.SystemState._V,
                        position: camera.PositionLabel._V
                    });
                });

                newSection.slides.push(newSlide);
            });
            newConfig.sections.push(newSection);
        });

        // round ip slides count
        newConfig.slidesCount = Math.ceil(newConfig.slidesCount);

        return newConfig;
    }
    
}